import { render, staticRenderFns } from "./FixedApps.vue?vue&type=template&id=5afe3832&scoped=true&"
import script from "./FixedApps.vue?vue&type=script&lang=js&"
export * from "./FixedApps.vue?vue&type=script&lang=js&"
import style0 from "./FixedApps.vue?vue&type=style&index=0&id=5afe3832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afe3832",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
